import useUser from '@hooks/auth/useUser';
import { BannerRow } from '@models/banner';
import { useFlow } from '@router/stackflow';
import NativeUtil from '@utils/NativeUtil';

function useOnBannerClick() {
  const { push } = useFlow();
  const { user } = useUser();
  return (banner: BannerRow) => {
    const {
      contentType, bannerLinkType, contentId, bannerLinkUrl,
    } = banner;
    if (contentType === 'EVENT' && bannerLinkType === 'CONTENT_DETAIL' && contentId) {
      push('EventActivity', { eventId: contentId });
      return;
    }
    if (contentType === 'NOTICE' && bannerLinkType === 'CONTENT_DETAIL' && contentId) {
      push('NoticeActivity', { noticeId: contentId });
      return;
    }
    if (bannerLinkType === 'STAMP') {
      if (user) {
        push('StampsActivity', {});
      } else {
        push('SignInActivity', {});
      }
      return;
    }
    if (bannerLinkType === 'LINK' && bannerLinkUrl) {
      NativeUtil.postMessage('openExternalLink', bannerLinkUrl);
    }
  };
}

export default useOnBannerClick;
